/**
 * Links aus Daten, die von außen kommen: Mailadresse und Website eines
 * Kunden, Leads oder Partners. Beide können aus dem öffentlichen
 * Anfrageformular stammen und stehen dann ungeprüft in der Datenbank.
 *
 * Gegenprüfung Mobil, 22.10.2026: Das Backend nahm als E-Mail
 * `info%40firma.de?bcc=angreifer@evil.example` an. Als `mailto:` setzt das
 * Mailprogramm daraus einen Empfänger `info@firma.de` und eine Blindkopie
 * an den Angreifer; am Handy zeigt der Knopf „E-Mail schreiben“ die Adresse
 * nicht einmal an. Deshalb wird nur verlinkt, was eine schlichte Adresse ist;
 * alles andere zeigt `Kontakt` als Text.
 */

// Genau ein @, davor und dahinter nichts, was in einer mailto:-URL etwas
// anderes bedeutet: ? (Kopfzeilen), & (weitere Kopfzeilen), % (kodierte
// Zeichen, auch ein kodiertes @), # / : (URL-Teile), Leer- und Steuerzeichen.
const SCHLICHTE_ADRESSE = /^[^\s\p{Cc}?&%#/:@]+@[^\s\p{Cc}?&%#/:@]+$/u;

/** `mailto:`-Adresse, oder `null`, wenn der Wert keine schlichte Mailadresse ist. */
export function mailHref(adresse: string): string | null {
  const wert = adresse.trim();
  return SCHLICHTE_ADRESSE.test(wert) ? `mailto:${wert}` : null;
}

/**
 * Website als Link, oder `null`, wenn sie nicht mit `http:` oder `https:`
 * beginnt. Damit wird aus `javascript:…` oder `data:…` kein Link; eine
 * Domain ohne Schema (`elbklar.com`) bleibt Text statt eines relativen
 * Links in die eigene App.
 */
export function webHref(url: string): string | null {
  try {
    const u = new URL(url.trim());
    return u.protocol === 'http:' || u.protocol === 'https:' ? u.href : null;
  } catch {
    return null;
  }
}

/**
 * Datei der eigenen App oder einer Website als Link „Original öffnen“: ein
 * Pfad derselben Herkunft (`/api/files/…`) oder `http(s):`. Alles andere
 * (`javascript:`, `data:`) wird kein Link.
 */
export function dateiHref(url: string): string | null {
  const wert = url.trim();
  if (wert.startsWith('/') && !wert.startsWith('//')) return wert;
  return webHref(wert);
}
